export const Button = {
  baseStyle: {},
  variants: {
    solid: {
      bg: 'brand.green',
      fontWeight: 600,
      color: 'brand.white',
      ':hover, :focus': {
        bg: 'brand.darkgreen',
      },
      ':hover:disabled': {
        bg: 'brand.green',
      }
    },
    outline: {
      borderColor: 'brand.green',
      fontWeight: 600,
      color: 'brand.darkgreen',
      ':hover, :focus': {
        bg: 'brand.green',
        color: 'brand.white',
      },
      wordWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      lineHeight: '20px',
      padding: ['24px 16px 24px 16px', '19px 16px 19px 16px']
    },
    grey: {
      bg: 'brand.lightgrey2',
      fontWeight: 600,
      color: 'brand.black',
    },
    link: { textDecoration: 'underline' },
  },
};
